<template>
  <transition name="el-zoom-in-top" @after-enter="handleEnter" @after-leave="handleLeave">
    <div
      v-show="visible"
      id="kye-date-picker2_date-panel"
      class="el-picker-panel el-date-picker el-popper kye-date-picker2_panel"
      :class="[{
        'has-sidebar': $slots.sidebar || shortcuts,
        'has-time': showTime,
        'has-footer': showFooter
      }, popperClass]">
      <div class="kye-date-picker2-flex">
        <slot name="sidebar"></slot>
        <ShortcutsWrap
          v-if="showShortcuts"
          :type="type"
          :shortcuts="shortcuts"
          :handleShortcutClick="handleShortcutClick"
          :currentView="currentView"
          :showMonthSelect="showMonthSelect"
          :changeShortcutMonth="changeShortcutMonth"
          :handleShortcutMonthClick="handleShortcutMonthClick"
          :disabledMonth="disabledMonth"
          >
        </ShortcutsWrap>
        <div>
          <div id="kye-date-picker2_date-panel-content" class="kye-date-picker2_panel-content">
            <div class="el-picker-panel__body-wrapper">
              <div class="el-picker-panel__body">
                <div
                  class="el-date-picker__header kye-date-picker2-header-wrap" :class="[showLocator ? 'flex-sb' : 'flex-center']">
                  <div class="left-wrap">
                    <button
                      type="button"
                      @click="prevYear"
                      :aria-label="t(`el.datepicker.prevYear`)"
                      class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left">
                    </button>
                    <button
                      type="button"
                      @click="prevMonth"
                      v-show="currentView === 'date'"
                      :aria-label="t(`el.datepicker.prevMonth`)"
                      class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left">
                    </button>
                    <YearSelect
                      class="m-r-8"
                      @pick="handleYearPick"
                      :selection-mode="selectionMode"
                      :default-value="defaultValue ? new Date(defaultValue) : null"
                      :date="date"
                      :disabled-date="disabledDate">
                    </YearSelect>
                    <MonthSelect
                      v-show="currentView === 'date'"
                      @pick="handleMonthPick"
                      :selection-mode="selectionMode"
                      :default-value="defaultValue ? new Date(defaultValue) : null"
                      :date="date"
                      :disabled-date="disabledDate">
                    </MonthSelect>
                    <button
                      type="button"
                      @click="nextMonth"
                      v-show="currentView === 'date'"
                      :aria-label="t(`el.datepicker.nextMonth`)"
                      class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right">
                    </button>
                    <button
                      type="button"
                      @click="nextYear"
                      :aria-label="t(`el.datepicker.nextYear`)"
                      class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right">
                    </button>
                  </div>
                  <kye-button
                    @click="locatorToToday"
                    class="locator-today"
                    type="text">
                    {{ currentView === 'date' ? '定位到今天': '定位到当月' }}
                  </kye-button>
                </div>

                <div class="el-picker-panel__content kye-date-picker2-date-table-wrap">
                  <date-table
                    v-show="currentView === 'date'"
                    @pick="handleDatePick"
                    :selection-mode="selectionMode"
                    :first-day-of-week="firstDayOfWeek"
                    :value="selectValue"
                    :default-value="defaultValue ? new Date(defaultValue) : null"
                    :date="date"
                    :showLunar="showLunar"
                    :cell-class-name="cellClassName"
                    :disabled-date="disabledDate">
                  </date-table>
                  <!-- <year-table
                    v-show="currentView === 'year'"
                    @pick="handleYearPick"
                    :selection-mode="selectionMode"
                    :value="value"
                    :default-value="defaultValue ? new Date(defaultValue) : null"
                    :date="date"
                    :disabled-date="disabledDate">
                  </year-table> -->
                  <month-table
                    v-show="currentView === 'month'"
                    @pick="handleMonthPick"
                    :selection-mode="selectionMode"
                    :value="selectValue"
                    :default-value="defaultValue ? new Date(defaultValue) : null"
                    :date="date"
                    :disabled-date="disabledDate">
                  </month-table>
                </div>
              </div>
            </div>
            <div class="kye-date-picker2-time-select-wrap" v-if="showTime">
              <TimeSetpSelect
                v-if="(stepOptions && stepOptions.length) || step"
                :step="step"
                :start="start"
                :end="end"
                :minTime="minTime"
                :maxTime="maxTime"
                :stepOptions="stepOptions"
                ref="timeStepPicker"
                @mounted="proxyTimePickerDataProperties"
                @pick="handleTimeStepPick">
              </TimeSetpSelect>
              <TimeSelect
                ref="timepicker"
                v-else
                @mounted="proxyTimePickerDataProperties"
                @pick="handleTimePick">
              </TimeSelect>
            </div>
          </div>
          <div
            class="el-picker-panel__footer"
            v-show="showFooter"
          >
            <el-button
              size="mini"
              type="text"
              @click="changeToNow"
              style="margin-left: 0 !important"
              v-show="selectionMode !== 'dates' && selectionMode !== 'months' && selectionMode !== 'years'">
              此刻
            </el-button>
            <el-button
              plain
              size="mini"
              @click="handleClear">
              重置
            </el-button>
            <el-button
              type="primary"
              size="mini"
              :disabled="!selectValue"
              @click="confirm">
              确定
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
  import moment from 'moment'
  import {
    // formatDate,
    parseDate,
    getWeekNumber,
    isDate,
    modifyDate,
    modifyTime,
    modifyWithTimeString,
    clearMilliseconds,
    clearTime,
    prevYear,
    nextYear,
    prevMonth,
    nextMonth,
    changeYearMonthAndClampDate,
    extractDateFormat,
    extractTimeFormat,
    timeWithinRange,
    modifyStartTime,
    modifyEndTime
  } from '../utils'
  import Clickoutside from 'element-ui/lib/utils/clickoutside'
  import Locale from 'element-ui/lib/mixins/locale'
  // import YearTable from '../basic/year-table'
  import MonthTable from '../basic/month-table'
  import YearSelect from '../basic/year-select'
  import MonthSelect from '../basic/month-select'
  import DateTable from '../basic/date-table'
  import TimeSelect from '../basic/time-select'
  import ShortcutsWrap from '../basic/shortcuts-wrap'
  import TimeSetpSelect from '../basic/time-step-select.vue'

  export default {
    mixins: [Locale],
    directives: { Clickoutside },
    watch: {
      // showTime(val) {
        /* istanbul ignore if */
        // if (!val) return
        // this.$nextTick(_ => {
        //   const inputElm = this.$refs.input.$el
        //   if (inputElm) {
        //     this.pickerWidth = inputElm.getBoundingClientRect().width + 10
        //   }
        // })
      // },
      value() {
        this.setDateValue()
      },
      activeInputIndex() {
        this.setDateValue()
      },
      defaultValue(val) {
        const _value = this.getDateValue()
        if (!isDate(_value)) {
          this.date = val ? new Date(val) : this.getInternalDateDefaultValue()
        }
      },
      visible(val) {
        if (!val) {
          this.setSelectValue(null)
        } else {
          if (!this.value[this.activeInputIndex]) {
            this.setSelectValue(null)
          }
        }
      },
      selectionMode(newVal) {
        if (newVal === 'month') {
          /* istanbul ignore next */
          if (this.currentView !== 'year' || this.currentView !== 'month') {
            this.currentView = 'month'
          }
        } else if (newVal === 'dates') {
          this.currentView = 'date'
        } else if (newVal === 'years') {
          this.currentView = 'year'
        } else if (newVal === 'months') {
          this.currentView = 'month'
        }
      }
    },
    methods: {
      setSelectValue(date) {
        this.selectValue = date
      },
      setDateValue() {
        const _value = this.getDateValue()
        if (this.selectionMode === 'dates' && this.value) return
        if (this.selectionMode === 'months' && this.value) return
        if (this.selectionMode === 'years' && this.value) return
        if (isDate(_value)) {
          this.date = new Date(_value)
        } else {
          this.date = this.getDefaultValue()
        }
        this.showTime && this.$nextTick(() => {
          if (this.$refs.timepicker) {
            this.$refs.timepicker.value = this.date
            setTimeout(() => this.$refs.timepicker.adjustSpinners())
          }
          if (this.$refs.timeStepPicker) {
            this.$refs.timeStepPicker.value = this.date
            setTimeout(() => this.$refs.timeStepPicker.scrollToOption())
          }
        })
        isDate(_value) && this.setSelectValue(this.date)
      },
      getDateValue(value) {
        const rangDate = value || this.value
        const _date = Array.isArray(rangDate) ? rangDate[this.activeInputIndex] : rangDate
        return _date
      },
      proxyTimePickerDataProperties() {
        const format = timeFormat => {
          if (this.$refs.timepicker) {
            this.$refs.timepicker.format = timeFormat
          }
          if (this.$refs.timeStepPicker) {
            this.$refs.timeStepPicker.format = timeFormat
          }
        }
        const value = () => {
          if (this.$refs.timepicker) {
            this.$refs.timepicker.value = this.getDefaultValue()
          }
          if (this.$refs.timeStepPicker) {
            this.$refs.timeStepPicker.value = this.getDefaultValue()
          }
        }
        const date = date => {
          if (this.$refs.timepicker) {
            this.$refs.timepicker.date = date
          }
          if (this.$refs.timeStepPicker) {
            this.$refs.timeStepPicker.date = date
          }
        }
        const selectableRange = selectableRange => {
          if (this.$refs.timepicker) {
            this.$refs.timepicker.selectableRange = selectableRange
          }
        }

        this.$watch('value', value)
        this.$watch('date', date)
        this.$watch('selectableRange', selectableRange)

        format(this.timeFormat)
        value()
        date(this.date)
        selectableRange(this.selectableRange)
      },

      handleClear() {
        this.date = this.getDefaultValue()
        this.selectValue = null
        this.$emit('pick', [])
        this.$emit('reset')
      },

      emit (value, ...args) {
        const dates = [this.value[0] || '', this.value[1] || '']
        dates[this.activeInputIndex] = value
        value = dates
        if (!value) {
          this.$emit('pick', value, ...args)
        } else if (Array.isArray(value)) {
          const _dates = value.map(date =>
            this.showTime
              ? clearMilliseconds(date)
              : clearTime(date)
          )
          this.$emit('pick', _dates, ...args)
        } else {
          this.$emit('pick', this.showTime ? clearMilliseconds(value) : clearTime(value), ...args)
        }
        this.userInputDate = null
        this.userInputTime = null
      },

      prevMonth() {
        this.date = prevMonth(this.date)
      },

      nextMonth() {
        this.date = nextMonth(this.date)
      },

      prevYear() {
        if (this.currentView === 'year') {
          this.date = prevYear(this.date, 10)
        } else {
          this.date = prevYear(this.date)
        }
      },

      nextYear() {
        if (this.currentView === 'year') {
          this.date = nextYear(this.date, 10)
        } else {
          this.date = nextYear(this.date)
        }
      },

      locatorToToday() {
        this.date = new Date()
      },
      changeShortcutMonth (val) {
        this.showMonthSelect = val
      },
      handleShortcutMonthClick (month) {
        this.handleMonthPick(month)

        const firstDayOfMonth = moment().month(month).date(1).startOf('day').toDate() // month() 中的参数是月份减一，因此 6 表示 7 月
        const lastDayOfMonth = moment().month(month).endOf('month').endOf('day').toDate()
        this.$emit('pick', [modifyStartTime(firstDayOfMonth), modifyEndTime(lastDayOfMonth)], false)
        this.changeShortcutMonth(false)
      },
      handleShortcutClick(shortcut) {
        if (shortcut.onClick) {
          shortcut.onClick(this)
        } else if (shortcut.text === '选择月') {
          this.changeShortcutMonth(true)
        } else if (typeof shortcut.value === 'function') {
          const date = shortcut.value()
          this.$emit('pick', date, false)
        }
      },

      handleTimePick(value) {
        if (isDate(value)) {
          const _value = this.selectValue
          if (this.defaultTime) {
            this.defaultTime[this.activeInputIndex] = moment(value).format(this.timeFormat)
          }
          const newDate = _value
            ? modifyTime(_value, value.getHours(), value.getMinutes(), value.getSeconds())
            : modifyWithTimeString(this.getDefaultValue(false) || value, this.getDefaultTime(), this.format)
          this.date = newDate
          isDate(_value) && this.setSelectValue(newDate)
        }
      },

      handleTimeStepPick(value) {
        if (isDate(value)) {
          const _value = this.selectValue
          if (this.defaultTime) {
            this.defaultTime[this.activeInputIndex] = moment(value).format(this.timeFormat)
          }
          const newDate = _value
            ? modifyTime(this.selectValue, value.getHours(), value.getMinutes(), value.getSeconds())
            : modifyWithTimeString(this.getDefaultValue(false) || value, this.defaultTime, this.format)
          this.date = newDate
          isDate(_value) && this.setSelectValue(newDate)
        }
      },

      handleTimePickClose() {
        this.timePickerVisible = false
      },

      handleMonthPick(month) {
        this.date = changeYearMonthAndClampDate(this.date, this.year, month)
        this.currentView = 'date'
      },

      handleDatePick(value) {
        if (this.selectionMode === 'day') {
          const _value = this.getDateValue()
          let newDate = _value
            ? modifyDate(_value, value.getFullYear(), value.getMonth(), value.getDate())
            : modifyWithTimeString(value, (this.getDefaultTime() || this.getDefaultValue(false) || this.date), this.format) // 使用this.date是存在没有选日期直接更改时间
          // change default time while out of selectableRange
          if (!this.checkDateWithinRange(newDate)) {
            newDate = modifyDate(this.selectableRange[0][0], value.getFullYear(), value.getMonth(), value.getDate())
          }
          this.date = newDate
          this.setSelectValue(newDate)
          if (!this.showTime) {
            this.emit(newDate, this.showTime)
          } else {
            this.$emit('prePick', newDate)
          }
        }
      },

      handleYearPick(year) {
        this.date = changeYearMonthAndClampDate(this.date, year, this.month)
      },

      changeToNow() {
        // NOTE: not a permanent solution
        //       consider disable "now" button in the future
        if ((!this.disabledDate || !this.disabledDate(new Date())) && this.checkDateWithinRange(new Date())) {
          this.date = new Date()
          this.emit(this.date)
        }
      },

      confirm() {
        let value = this.selectValue
        if (!value) {
          value = modifyWithTimeString(this.getDefaultValue(), this.getDefaultTime(), this.format)
        }
        // this.value.filter(Boolean).length === 2 范围存在先选右边在选左边
        if (this.singleValue || this.value.filter(Boolean).length >= 1) {
          this.date = new Date(value)
          this.emit(value)
        } else {
          this.handleRangeLeftConfirm(value)
        }
      },

      handleRangeLeftConfirm(value) {
        this.value[this.activeInputIndex] = value
        this.$emit('dateTimeRange', {
          newDate: value
        })
      },

      resetView() {
        if (this.selectionMode === 'month' || this.selectionMode === 'months') {
          this.currentView = 'month'
        } else if (this.selectionMode === 'year' || this.selectionMode === 'years') {
          this.currentView = 'year'
        } else {
          this.currentView = 'date'
        }
      },

      handleEnter() {
        document.body.addEventListener('keydown', this.handleKeydown)
        this.showTime && this.$nextTick(() => {
          if (this.$refs.timeStepPicker) {
            this.$refs.timeStepPicker.scrollToOption()
          }
        })
      },

      handleLeave() {
        this.$emit('dodestroy')
        document.body.removeEventListener('keydown', this.handleKeydown)
      },

      handleKeydown(event) {
        // const keyCode = event.keyCode
        // const list = [38, 40, 37, 39]
        // if (this.visible && !this.timePickerVisible) {
        //   if (list.indexOf(keyCode) !== -1) {
        //     this.handleKeyControl(keyCode)
        //     event.stopPropagation()
        //     event.preventDefault()
        //   }
        //   if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) { // Enter
        //     this.emit(this.date, false)
        //   }
        // }
      },

      handleKeyControl(keyCode) {
        const mapping = {
          'year': {
            38: -4, 40: 4, 37: -1, 39: 1, offset: (date, step) => date.setFullYear(date.getFullYear() + step)
          },
          'month': {
            38: -4, 40: 4, 37: -1, 39: 1, offset: (date, step) => date.setMonth(date.getMonth() + step)
          },
          'week': {
            38: -1, 40: 1, 37: -1, 39: 1, offset: (date, step) => date.setDate(date.getDate() + step * 7)
          },
          'day': {
            38: -7, 40: 7, 37: -1, 39: 1, offset: (date, step) => date.setDate(date.getDate() + step)
          }
        }
        const mode = this.selectionMode
        const year = 3.1536e10
        const now = this.date.getTime()
        const newDate = new Date(this.date.getTime())
        while (Math.abs(now - newDate.getTime()) <= year) {
          const map = mapping[mode]
          map.offset(newDate, map[keyCode])
          if (typeof this.disabledDate === 'function' && this.disabledDate(newDate)) {
            continue
          }
          this.date = newDate
          this.$emit('pick', newDate, true)
          break
        }
      },

      handleVisibleTimeChange(value) {
        const time = parseDate(value, this.timeFormat)
        if (time && this.checkDateWithinRange(time)) {
          this.date = modifyDate(time, this.year, this.month, this.monthDate)
          this.userInputTime = null
          this.$refs.timepicker && (this.$refs.timepicker.value = this.date)
          this.emit(this.date, true)
        }
      },

      handleVisibleDateChange(value) {
        const date = parseDate(value, this.dateFormat)
        if (date) {
          if (typeof this.disabledDate === 'function' && this.disabledDate(date)) {
            return
          }
          this.date = modifyTime(date, this.date.getHours(), this.date.getMinutes(), this.date.getSeconds())
          this.userInputDate = null
          this.resetView()
          this.emit(this.date, true)
        }
      },

      isValidValue(value) {
        return value && !isNaN(value) && (
          typeof this.disabledDate === 'function'
            ? !this.disabledDate(value)
            : true
        ) && this.checkDateWithinRange(value)
      },

      getDefaultValue(isUseInternal = true) {
        return this.defaultValue
          ? new Date(this.defaultValue)
          : (isUseInternal ? this.getInternalDateDefaultValue() : '')
      },
      getInternalDateDefaultValue() {
        const isRight = this.activeInputIndex === 1
        const defaultDate = new Date()
        isRight ? defaultDate.setHours(23, 59, 59, 0) : defaultDate.setHours(0, 0, 0, 0)
        const date = new Date(modifyWithTimeString(defaultDate, this.getDefaultTime(), this.format))
        return isRight ? nextMonth(date) : date
      },
      getDefaultTime() {
        const defaultTime = this.defaultTime || []
        return defaultTime[this.activeInputIndex]
      },

      checkDateWithinRange(date) {
        return this.selectableRange.length > 0
          ? timeWithinRange(date, this.selectableRange, this.format || 'HH:mm')
          : true
      },
    },

    components: {
      YearSelect,
      MonthSelect,
      // YearTable,
      MonthTable,
      TimeSelect,
      DateTable,
      ShortcutsWrap,
      TimeSetpSelect
    },

    data() {
      return {
        popperClass: '',
        date: new Date(),
        value: [],
        defaultValue: null, // use getDefaultValue() for time computation
        defaultTime: null,
        showTime: false,
        selectionMode: 'day',
        shortcuts: [],
        visible: false,
        currentView: 'date',
        disabledDate: '',
        disabledMonth: '', // 禁用快捷面板月份callback
        cellClassName: '',
        selectableRange: [],
        firstDayOfWeek: 7,
        showWeekNumber: false,
        format: '',
        arrowControl: false,
        userInputDate: null,
        userInputTime: null,
        showShortcuts: true,
        showLocator: true,
        activeInputIndex: 0,
        selectValue: null,
        showMonthSelect: false,
        singleValue: false,
        type: 'datetimerange',

        // 时间范围设置
        start: '00:00',
        end: '23:59',
        step: '',
        minTime: '',
        maxTime: '',
        stepOptions: []
      }
    },

    computed: {
      year() {
        return this.date.getFullYear()
      },

      month() {
        return this.date.getMonth()
      },

      week() {
        return getWeekNumber(this.date)
      },

      monthDate() {
        return this.date.getDate()
      },

      footerVisible() {
        return this.showTime || this.selectionMode === 'dates' || this.selectionMode === 'months' || this.selectionMode === 'years'
      },

      // visibleTime() {
      //   if (this.userInputTime !== null) {
      //     return this.userInputTime
      //   } else {
      //     return formatDate(this.value || this.defaultValue, this.timeFormat)
      //   }
      // },

      // visibleDate() {
      //   if (this.userInputDate !== null) {
      //     return this.userInputDate
      //   } else {
      //     const _value = this.getDateValue()
      //     return formatDate(_value || this.defaultValue, this.dateFormat)
      //   }
      // },

      // yearLabel() {
      //   const yearTranslation = this.t('el.datepicker.year')
      //   if (this.currentView === 'year') {
      //     const startYear = Math.floor(this.year / 10) * 10
      //     if (yearTranslation) {
      //       return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation
      //     }
      //     return startYear + ' - ' + (startYear + 9)
      //   }
      //   return this.year + ' ' + yearTranslation
      // },

      timeFormat() {
        if (this.format) {
          return extractTimeFormat(this.format) || 'HH:mm'
        } else {
          return 'HH:mm'
        }
      },

      dateFormat() {
        if (this.format) {
          return extractDateFormat(this.format)
        } else {
          return 'yyyy-MM-dd'
        }
      },
      showFooter () {
        return this.footerVisible && (this.currentView === 'date' || this.currentView === 'month' || this.currentView === 'year')
      }
    }
  }
</script>

<style lang="scss">
.key-date-picker2_panel{
  .el-picker-panel__icon-btn{
    margin-top: 0 !important;
  }
  .kye-date-picker2_month-select{
    margin-left: 8px;
  }
  .el-range-editor--mini{
    .el-range-separator{
      line-height: 33px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker2/src/panel/date-time-range.vue